import React, { useCallback, useMemo, useRef } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { TreeView } from '../../../../../common/components/layout';
import { getCenteredEntities, getEntitiesWithVisibility } from '../../../../../map/utils/mapFunctions';
import { CoverageExact } from '../../../../../mission/models/Coverage';

const HyspexCoverageTreeView = ({ hyspexCoverage, setHyspexCoverage, setCenteredGeometries, disabled }) => {
  const handleCoverageCenterClick = useCallback(
    (item) => {
      setCenteredGeometries(getCenteredEntities(hyspexCoverage, item.id));
    },
    [hyspexCoverage, setCenteredGeometries]
  );

  const handleCoverageVisibilityClick = useCallback(
    (item, isToggled) => {
      setHyspexCoverage((oldCoverage) => getEntitiesWithVisibility(oldCoverage, item.id, isToggled));
    },
    [setHyspexCoverage]
  );

  const { current: coverageItemActions } = useRef([
    { id: 'hyspex-coverage-center', icons: { default: 'gps_fixed' }, onClick: handleCoverageCenterClick },
    {
      id: 'hyspex-coverage-visibility',
      icons: { default: 'visibility', toggled: 'visibility_off' },
      onClick: handleCoverageVisibilityClick,
    },
  ]);

  const coverageItems = useMemo(
    () => [
      {
        id: 'root',
        label: i18n.t('patrol.details.hyspexCoverage'),
        actions: coverageItemActions,
        disabled,
      },
    ],
    [coverageItemActions, disabled]
  );

  return <TreeView id="hyspex-coverage" items={coverageItems} />;
};

HyspexCoverageTreeView.propTypes = {
  hyspexCoverage: PropTypes.arrayOf(CoverageExact),
  setHyspexCoverage: PropTypes.func.isRequired,
  setCenteredGeometries: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

HyspexCoverageTreeView.defaultProps = {
  hyspexCoverage: [],
  disabled: false,
};

export default HyspexCoverageTreeView;
